import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import IntroductionToOurPrivacyPolicy from "./sections/IntroductionToOurPrivacyPolicy";
import HowWeHandleYourData from "./sections/HowWeHandleYourData";
import YourRightsAndContactInformation from "./sections/YourRightsAndContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <IntroductionToOurPrivacyPolicy />
      <HowWeHandleYourData />
      <YourRightsAndContactInformation />
      <Footer />
    </div>;
}